import styled, { css } from 'styled-components';

import { Card } from "../Card";
import { Arrow } from "../Icons";

export const FilterButtonWrap = /*#__PURE__*/styled(Card).withConfig({ displayName: "styles__FilterButtonWrap", componentId: "sc-1djka95-0" })(["user-select:none;position:relative;padding:12px ", ";color:", ";", ";display:flex;justify-content:space-between;align-items:center;cursor:pointer;"],


(props) => props.theme.spacers.L,
(props) => props.theme.colors['Level 4'],
({ theme }) => css(theme.typography.Paragraph));






export const Icon = /*#__PURE__*/styled(Arrow).withConfig({ displayName: "styles__Icon", componentId: "sc-1djka95-1" })(["color:", ";transform:rotate(-90deg);"],
(props) => props.theme.colors['Level 3']);



export const RippleContainer = /*#__PURE__*/styled.div.withConfig({ displayName: "styles__RippleContainer", componentId: "sc-1djka95-2" })(["border-radius:4px;width:100%;height:100%;position:absolute !important;top:0;left:0;"]);